import React from 'react';
import StencilThickness from 'shared/components/parameters/StencilThickness';
import StencilPrinterName from 'shared/components/parameters/StencilPrinterName';
import StencilFiducialData from 'shared/components/parameters/StencilFiducialData';

import FrameSize from 'shared/product_tabs/tab_stencils/components/FrameSize';
import ApertureCount from 'shared/product_tabs/tab_stencils/components/ApertureCount';

const FramedSmtStencil = ({ product, onChangeParameter, parameters, validator }) => (
  <div className="product-parameters row">
    <div className="col-12 col-sm-6 col-lg-3">
      <FrameSize
        variants={product.variants}
        parameters={parameters}
        onChangeParameter={onChangeParameter}
        errorMessage={validator.message('Frame Size', parameters.stencil_frame_size, 'required')} />
    </div>
    <div className="col-12 col-sm-6 col-lg-3">
      <ApertureCount
        variants={product.variants}
        parameters={parameters}
        onChangeParameter={onChangeParameter}
        errorMessage={validator.message('Aperture Count', parameters.aperture_count, 'required')} />
    </div>
    <div className="col-12 col-sm-6 col-lg-3">
      <StencilThickness
        required
        name="stencil_thickness"
        parameters={parameters}
        onChangeParameter={onChangeParameter}
        errorMessage={validator.message('Stencil Thickness', parameters.stencil_thickness, 'required')} />
    </div>
    <div className="col-12 col-sm-6 col-lg-3">
      <StencilFiducialData
        parameters={parameters}
        onChangeParameter={onChangeParameter}
        errorMessage={validator.message('Fiducial Data', parameters.fiducial_data, 'required')} />
    </div>
    <div className="col-12 col-sm-6 col-lg-3">
      <StencilPrinterName
        parameters={parameters}
        onChangeParameter={onChangeParameter}
        errorMessage={validator.message('Printer Name', parameters.printer_type, 'required')} />
    </div>
  </div>
);

export default FramedSmtStencil;